/**
 * CommandParameterTemplate - defines a parameter of a command. A
 * parameter must have a name and a type and can have a value. If
 * it has a value, this comes already from the backend. E.g.: a command
 * that is rendered to deleted a specific entity needs the id of the
 * entity. During rendering of the command on the backend, this 
 * parameter will be renderes as value. If a parameter value is
 * empty, this means that the frontend has provide a value for this 
 * parameter.
 */
export class CommandParameterTemplate {
  name: string;
  type: string;
  value: any | undefined;

  constructor(payload?: any) {
    if (payload) {
      this.name = payload.name;
      this.type = payload.type;
      this.value = payload.value;
    }
  }

}


